const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

async function apiFetch(path, options = {}) {
  const url = `${BACKEND_URL}${path}`;
  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || `API error: ${response.status}`);
  }

  return response.json();
}

export const api = {
  getArtists: (q = '') => apiFetch(`/api/artists${q ? `?q=${encodeURIComponent(q)}` : ''}`),
  getArtist: (spotifyId) => apiFetch(`/api/artists/${spotifyId}`),
  getReleases: (q = '') => apiFetch(`/api/releases${q ? `?q=${encodeURIComponent(q)}` : ''}`),
  submitContact: (data) => apiFetch('/api/contact', { method: 'POST', body: JSON.stringify(data) }),
};
